<div class="mitra-blog-details">
    <div class="container-fluid">
        <div class="row breadcrumb-wrapper">
            <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <div class="container">
                    <div class="row">
                        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                            <app-breadcrumb *ngIf="showBreadCrumb"></app-breadcrumb>                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="banner-bog-details">
        <img alt="Banner" *ngIf="detailList?.image_path" src="{{detailList?.image_path}}" class="img-fluid" loading="lazy"/>
        <div class="ratio  ratio-21x9" *ngIf="detailList?.youtube_url">
            <iframe class="detail-vedio-h-w" [src]="detailList?.youtube_url | safe:'resourceUrl'" frameborder="0" allowfullscreen></iframe>
        </div>

    </div>
    <div class="row blog-details-content">
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <div class="container">
                <div class="row">
                    <div class="col-12 col-sm-12 col-md-12 col-lg-8 col-xl-8 position-relative">
                        <span class="badge-blog">{{detailList?.type}}</span>
                        <div class="ct">
                            <h3 class="blog-title">{{detailList?.title}}</h3>
                            <div class="date-time">{{detailList?.created_date  | date: 'MMM dd yyyy'}}</div>
                        </div>

                        <div class="blog-desc" [innerHTML]="detailList?.description">
                        </div>
                    </div>
                    <div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4 recent-post-sec">
                        <h1 class="page-sub-title cv-text-dark">Recent Posts</h1>
                        <div class="row">
                            <div class="col-12 col-sm-12 col-md-6 col-lg-12 col-xl-12" *ngFor="let item of recentBlogs">
                                <div class="recentpost-item" >
                                    <div class="image-wrapper">
                                        <div class="ratio ratio-4x3" *ngIf="item?.youtube_url">
                                            <iframe [src]="item.youtube_url | safe:'resourceUrl'" frameborder="0"
                                                allowfullscreen></iframe>
                                        </div>
                                        <img alt="{{item?.model}}" *ngIf="item?.image_path" src="{{item?.image_path}}" loading="lazy"/>
                                    </div>
                                    <div class="content-wrapper">
                                        <div class="date-time">{{item.created_date  | date: 'MMM dd yyyy'}}</div>
                                        <div class="desc text-ellipsis-3-line cursor" (click)="gotoPath(item?.title,item?.id)">
                                            {{item.title}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
